var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "goods_preview" }, [
    _c("div", { staticClass: "goods_preview_wrapper" }, [
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "preview_body" },
            [
              _vm.sliderImages.length
                ? _c(
                    "el-carousel",
                    {
                      attrs: {
                        height: "375px",
                        "indicator-position": "none",
                        arrow: "always",
                      },
                    },
                    _vm._l(_vm.sliderImages, function (img, i) {
                      return _c("el-carousel-item", { key: i }, [
                        _c("img", {
                          staticClass: "preview_img",
                          attrs: { src: img, alt: "" },
                        }),
                      ])
                    }),
                    1
                  )
                : _c("div", { staticClass: "preview_img_wrap" }, [
                    _c("img", {
                      staticClass: "preview_img",
                      attrs: { src: _vm.info.image, alt: "" },
                    }),
                  ]),
              _c("div", { staticClass: "preview_info" }, [
                _c("div", { staticClass: "preview_price" }, [
                  _c("span", { staticClass: "rmb" }, [_vm._v("￥")]),
                  _vm._v(_vm._s(_vm.info.price) + " "),
                ]),
                _c("div", { staticClass: "preview_name" }, [
                  _vm._v(_vm._s(_vm.info.name)),
                ]),
              ]),
              _c("div", {
                staticClass: "preview_content",
                domProps: {
                  innerHTML: _vm._s(_vm.info.content || "暂无商品详情"),
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("div", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "preview_loading",
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }